import camelCase from 'camel-case'
import * as Sentry from '@sentry/react'
import { Dispatch } from '~/app/store/types'
import { ActionTypes, Notification, ROUTE_ACTIONS } from './types'
import { createGaPageView, setGaAttribute } from '~/helpers/gaHelper'
import { PATHS } from '~/app/routes/paths'
import { get, put, ENDPOINTS } from '~/api'

export const redirect = (to: PATHS) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: ROUTE_ACTIONS.SET_REDIRECT,
    to,
  })
}

export const resetRedirect = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: ROUTE_ACTIONS.SET_REDIRECT,
    to: null,
  })
}

export const init = () => (dispatch: Dispatch<ActionTypes>) => {
  Promise.all([get(ENDPOINTS.API_SSO_PROFILE), get(ENDPOINTS.API_V3_USER_PROFILE)]).then(
    ([ssoProfileResp, userProfileResp]) => {
      Sentry.setUser({
        id: ssoProfileResp.kc_id,
        email: ssoProfileResp.email,
      })
      setGaAttribute({ userId: ssoProfileResp.kc_id }) // unsure if i should set it here
      createGaPageView(window.location.pathname + window.location.search)
      dispatch({
        type: ROUTE_ACTIONS.SET_USER_PROFILE,
        user: {
          kcId: ssoProfileResp.kc_id,
          fullName: userProfileResp.full_name,
          email: ssoProfileResp.email,
          mobileNumber: ssoProfileResp.mobile_number,
          avatarUrl: userProfileResp.avatar_url,
          displayname: userProfileResp.displayname,
        },
      })

      dispatch({
        type: ROUTE_ACTIONS.SET_TRANSACTION_ACCOUNTS,
        /* eslint-disable @typescript-eslint/no-explicit-any */
        accounts: userProfileResp.accounts.map((acc: any) => {
          const newAcc: any = {}
          Object.keys(acc).forEach(key => {
            newAcc[camelCase(key)] = acc[key]
          })
          return newAcc
        }),
      })
    }
  )

  // fetching notifications in the init function, it only needs to be fetched once at the beginning of the session and stored in redux
  dispatch(fetchNotifications())
}

export const fetchAccounts = () => (dispatch: Dispatch<ActionTypes>) => {
  get(ENDPOINTS.API_XFERS_ACCOUNTS).then(resp => {
    dispatch({
      type: ROUTE_ACTIONS.SET_TRANSACTION_ACCOUNTS,
      /* eslint-disable @typescript-eslint/no-explicit-any */
      accounts: resp.map((account: any) => {
        const newAccount: any = {}
        Object.keys(account).forEach(key => {
          newAccount[camelCase(key)] = account[key]
        })
        return newAccount
      }),
    })
  })
}

export const updateUserProfile = ({
  deleteAvatar,
  displayImage,
}: {
  deleteAvatar?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  displayImage?: { fileData?: any; fileName?: any }
}) => (dispatch: Dispatch<ActionTypes>) => {
  put(ENDPOINTS.API_V3_UPDATE_USER_PROFILE, {
    delete_avatar: deleteAvatar,
    display_image: displayImage
      ? {
          file_data: displayImage.fileData,
          file_name: displayImage.fileName,
        }
      : null,
  })
    .then(resp => {
      dispatch({
        type: ROUTE_ACTIONS.UPDATE_USER_PROFILE,
        avatarUrl: resp.display_image.file_data,
      })
    })
    .catch(() => {
      // alert('error')
    })
}

export const fetchNotifications = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch({
    type: ROUTE_ACTIONS.TOGGLE_NOTIFICATIONS_LOADING,
    isLoading: true,
  })

  get(ENDPOINTS.API_XFERS_USER_MESSAGES).then(resp => {
    const unreadCount = resp.filter((notification: Notification) => notification.is_read === 0)
      .length

    dispatch({
      type: ROUTE_ACTIONS.SET_NOTIFICATIONS,
      data: resp,
      unreadCount,
      isLoading: false,
    })
  })
}
